 import { StockMovement } from "../types/stockMovement";
import { createApiStore } from "./genericStore";
 
export const useStockMovementStore = createApiStore<StockMovement>("/stockMovement");
